module.exports = __webpack_public_path__ + "img/leona_10_ocular.79eef013.jpg";